export default __webpack_public_path__ + "101bb099a48dfab77a958e6336d248d5.png";